<template>
  <div class="page" :class="pageClasses">
    <flash-notifications/>
    <messaging-modal v-if="isAuthenticated"/>
    <confirmation-modal v-if="isAuthenticated"/>
    <local-modal-wrapper/>
    <header-bar v-if="showHeader"/>
    <mobile-menu/>

    <div v-if="showHeader"
         class="mock-header"
         :class="{ 'mock-header--with-hero': hasHero, 'mock-header--dashboard': isDashboard, 'mock-header--account': isAccount }">
    </div>

    <b-container fluid class="content-wrapper" :class="`content-wrapper--${lowercaseRouteName}`">
      <b-row>
        <b-col>
          <slot />
        </b-col>
      </b-row>
    </b-container>

    <footer class="footer-container">
      <app-footer :white="whiteFooter"/>
    </footer>

    <cookie-consent/>
    <image-lightbox/>
  </div>
</template>

<script lang="js">
import { mapActions, mapState } from 'vuex'
import { compose, path, pathOr, toLower } from 'ramda'
import CookieConsent from './CookieConsent'
import MessagingModal from '../MessagingModal'
import ConfirmationModal from './Confirmations/ConfirmationModal'
import FlashNotifications from './FlashNotifications.vue'
import AppFooter from './AppFooter.vue'
import HeaderBar from './HeaderBar'
import LocalModalWrapper from '../LocalModal/LocalModalWrapper'
import MobileMenu from './MobileMenu'
import ImageLightbox from '../ImageLightbox.vue'

export default {
  name: 'PageTemplate',
  components: {
    ImageLightbox,
    CookieConsent,
    MobileMenu,
    LocalModalWrapper,
    HeaderBar,
    MessagingModal,
    AppFooter,
    FlashNotifications,
    ConfirmationModal,
  },
  computed: {
    ...mapState(
      {
        userName: path(['auth', 'user', 'data', 'attributes', 'fullName']),
        isAuthenticated: path(['auth', 'isAuthenticated']),
        floatingFooterVisible: path(['floatingFooterVisible']),
      },
    ),
    hasHero() {
      return path(['$route', 'meta', 'hasHero'], this)
    },
    isDashboard() {
      return path(['$route', 'name'])(this) === 'Dashboard'
    },
    isAccount() {
      return path(['$route', 'name'])(this) === 'Account'
    },
    pageClasses() {
      let classes = pathOr('', ['$route', 'meta', 'pageClasses'], this)

      if (this.floatingFooterVisible) {
        classes = `${classes} page--floating-footer-visible`
      }

      return classes
    },
    lowercaseRouteName() {
      return compose(toLower, String, path(['$route', 'name']))(this)
    },
    whiteFooter() {
      return compose(Boolean, path(['$route', 'meta', 'whiteFooter']))(this)
    },
    showHeader() {
      return this.isAuthenticated || path(['$route', 'meta', 'forceHeader'], this)
    },
  },
  methods: {
    ...mapActions(
      {
        logout: 'auth/logout',
      },
    ),
    checkAuthenticated() {
      if (!this.isAuthenticated) {
        this.$router.replace('/login')
      }
    },
  },
}
</script>
